<template>
    <div class="row">
        <div class="col-md-12">
            <seccion-datos :titulo="autovisita" :botonGuardar="false" class="card">
                <div>
                    <label for="">Vehículo</label>
                    <select v-model="vehiculo_seleccionado" class="form-control" name="" id="">
                        <option value="">--Selecciona vehículo--</option>
                    </select>
                </div>
                <div>
                    <label for="">Botón "Estoy en domicilio" aparece con GPS de:</label>
                    <select v-model="gps_seleccionado" class="form-control" name="" id="">
                        <option value="app_movil">App movil</option>
                        <option value="vehiculo">Vehículo</option>
                    </select>
                </div>
            </seccion-datos>
        </div>
    </div>
</template>
<script>
export default {
    props: ['id', 'operario', 'coordenadas_operario', 'cargaauto'],
    data() {
        return {
            vehiculo_seleccionado: '',
            vehiculos: [],
            gps_seleccionado: 'app_movil',
        }
    },
    components: {
    },
    methods: {
        async cargardatos() {
        },
    },
}
</script>
<style>
.map-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
}

#map {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
